
//-----------------------|| SAMPLE PAGE & DOCUMENTATION MENU ITEMS ||-----------------------//

export const other = {
    id: 'logout',
    type: 'group',
    children: [
        {
            id: 'admin.view_logentry',
            title: 'Logout',
            type: 'item',
            url: '/logout',
            icon: 'IconLogout',
            breadcrumbs: false
        },
        
    ]
};
